import React from 'react';
import { BadgeCheckIcon, ClipboardCheckIcon, LanguagesIcon, ShieldCheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
const badges = [{
  icon: ShieldCheckIcon,
  titleKey: 'trust.licensed',
  subKey: 'trust.licensed.sub'
}, {
  icon: BadgeCheckIcon,
  titleKey: 'trust.years',
  subKey: 'trust.years.sub'
}, {
  icon: ClipboardCheckIcon,
  titleKey: 'trust.free',
  subKey: 'trust.free.sub'
}, {
  icon: LanguagesIcon,
  titleKey: 'trust.spanish',
  subKey: 'trust.spanish.sub'
}];
export function TrustBar() {
  const {
    t
  } = useLanguage();
  return <section aria-label="Credentials" className="w-full border-b border-navy-900/10 bg-white" data-id="element-282" data-mp="1gzh1xnyeb3e5">
      <ul className="mx-auto grid max-w-7xl grid-cols-1 gap-x-8 gap-y-6 px-4 py-8 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:px-8" data-id="element-283" data-mp="1lybh8fx5m9ti">
        {badges.map(badge => {
        const Icon = badge.icon;
        return <li key={badge.titleKey} className="flex items-start gap-3" data-id="element-284" data-mp="ajo9m57y8jg8">
              <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-forest-600/10 text-forest-600" data-id="element-285" data-mp="1aix91m8g70tz">
                <Icon className="h-5 w-5" strokeWidth={2.2} aria-hidden="true" data-id="element-286" data-mp="16idbwinvjx7u" />
              </span>
              <span data-id="element-287" data-mp="1ki4ihyc2abbt">
                <span className="block font-display text-sm font-bold text-navy-900" data-id="element-288" data-mp="1kio1zjhd17ry">
                  {t(badge.titleKey)}
                </span>
                <span className="mt-0.5 block text-sm text-navy-900/60" data-id="element-289" data-mp="1thjbb4fpaxzh">{t(badge.subKey)}</span>
              </span>
            </li>;
      })}
      </ul>
    </section>;
}